import {config} from '../config';

const getIsConnectCareEnabledByType = (deviceType) => {
    const deviceTypeList = config.data.deviceDiagnostic.connectCare;

    return deviceTypeList?.some((item) => item === deviceType);
};

const getIsAdvancedDeviceDiagnosticEnabledByType = (deviceType) => {
    const deviceTypeList = config.data.deviceDiagnostic.advancedDiagnostic;

    return deviceTypeList?.some((item) => item === deviceType);
};

const getIsQuestionnaireEnabledByType = (deviceType) => {
    const isQuestionnaireEnabled = config.data.deviceDiagnostic.isQuestionnaireEnabled;
    const deviceTypeList = config.data.deviceDiagnostic.questionnaireDisabled;

    const isQuestionnaireDisabledByType = deviceTypeList?.some((item) => item === deviceType);

    return isQuestionnaireEnabled && !isQuestionnaireDisabledByType;
};

export default {
    getIsConnectCareEnabled: (deviceType) => getIsConnectCareEnabledByType(deviceType),
    getIsAdvancedDeviceDiagnosticEnabled: (deviceType) => getIsAdvancedDeviceDiagnosticEnabledByType(deviceType),
    getIsQuestionnaireEnabled: (deviceType) => getIsQuestionnaireEnabledByType(deviceType),
    getIsErrorCodeDisplayingEnabled: () => config.data.deviceDiagnostic.isErrorCodeDisplayingEnabled,
    getFinishDeviceDiagnosticButtonDisplayTime: () =>
        config.data.deviceDiagnostic.finishDeviceDiagnosticButtonDisplayTime,
    getMaxFailedAttempts: () => config.data.deviceDiagnostic.maxFailedAttempts,
    getMaxSuccessfulAttempts: () => config.data.deviceDiagnostic.maxSuccessfulAttempts,
};
